export default __webpack_public_path__ + "static/media/KWENTA.c9071d5c.png";